import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import componentColor, { dls, smartQareExtendedPalette } from '../../compat/colors';
import { CircularProgress } from '../../compat/core';

import { BrandLogo } from '../../components/BrandLogo';
import { SplashTheme } from './SplashTheme';
import { SplashScreenProps } from './types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100vw;
  min-height: 100vh;
  background: radial-gradient(
    circle farthest-side,
    ${componentColor(dls.light.lightCenter.default.normal)},
    ${componentColor(dls.light.lightEdge.default.normal)}
  );
  background-attachment: fixed;
  background-color: ${componentColor(dls.loginScreen.background.default.normal)};
  background-size: cover;
  color: ${componentColor(dls.loginScreen.text.default.normal)};
`;

const SplashBrandLogo = styled(BrandLogo).attrs({
  variant: 'full',
  size: 'lg',
})`
  width: min(76vw, 280px);
  min-width: 160px;
  height: auto;
  margin: calc((70.8vh - 48px) / 2) 0 14.6vh;
`;

const Title = styled.h1`
  margin: 0 0 48px;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
`;

const LoadingText = styled.span`
  margin-top: 8px;
  color: ${smartQareExtendedPalette.textOnDarkSecondary};
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
`;

export const SplashScreen: FunctionComponent<SplashScreenProps> = ({
  title,
  loading,
  loadingText,
}) => (
  <SplashTheme>
    <Container>
      <SplashBrandLogo />
      <Title>{title}</Title>
      {loading && <CircularProgress dls_size="medium" variant="indeterminate" />}
      {loadingText && <LoadingText>{loadingText}</LoadingText>}
    </Container>
  </SplashTheme>
);
